import React from 'react';
import {Field} from 'react-final-form';
import {TextInputSize} from '@yandex-data-ui/common';

import {parseBytes} from 'utils';
import {FormFieldRangeInputPicker} from 'components/formFields';
import {getMemSizeLabel} from 'components/calculator/MDBForm/utils';
import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

interface SizeRangeStepInputProps extends WithTranslationProps {
    name: string;
    size: TextInputSize;
    steps?: number[];
    readOnly?: boolean;
    onUpdate?: (value: number) => void;
    infoPointsCount?: number;
}

const SizeRangeStepInput: React.FC<SizeRangeStepInputProps> = ({
    name,
    steps,
    readOnly,
    size,
    onUpdate,
    i18n,
    infoPointsCount,
}) => (
    <Field name={name}>
        {(fieldProps) => (
            <FormFieldRangeInputPicker
                {...fieldProps}
                size={size}
                minValue={steps?.[0]}
                maxValue={steps?.[steps.length - 1]}
                availableValues={steps}
                infoPointsCount={infoPointsCount || steps?.length}
                format={(value?: number) => getMemSizeLabel(value || 0, i18n)}
                parse={(str: string) => parseBytes(str, 'gb')}
                readOnly={readOnly}
                onUpdate={onUpdate}
            />
        )}
    </Field>
);

export default withTranslation()(SizeRangeStepInput);
